export default {
    path: '/xyz',
    name: 'xyz',
    component: () => import(/*webpackChunkName: 'styleguide'*/ '@/views/Styleguide.vue')
};
